module.exports = __webpack_public_path__ + "img/router.781b2ac0.svg";